/**
 *
 * 华泰证券
 *
 */

import { getUrlParam } from '@/utils/api';
import { THIRDPARTY } from '@/utils/const';

const comein_channel = 'huataizq';

export const isThirdParty =
	getUrlParam().comein_channel === comein_channel ||
	JSON.parse(sessionStorage.getItem(THIRDPARTY) || '{}').comein_channel === comein_channel;

function Bridge() {
	this.showMenu = false;

	this.comein_channel = comein_channel;

	this.authMethod = 2;
}

export default Bridge;
